export default __webpack_public_path__ + "static/media/landing-opposing-hitter-views.df3cff5d.png";